export default __webpack_public_path__ + "static/media/project1.191a7fd7.jpg";